// extracted by mini-css-extract-plugin
export default {"cardCont":"Cards_cardCont__5Tg3C","cardContainer":"Cards_cardContainer__U1BRO","cardImage":"Cards_cardImage__9N0oo","contents":"Cards_contents__ZZlFV","btns":"Cards_btns__7Ysd9"};